'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = require('../../../assets/icons/warning');

var _warning2 = _interopRequireDefault(_warning);

var _Svg = require('../Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertSymbol = function AlertSymbol(props) {
  return _react2.default.createElement(_Svg2.default, {
    viewBox: '0 0 24 24',
    width: props.width,
    height: props.height,
    svgPath: _warning2.default,
    color: props.color
  });
};

AlertSymbol.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  color: _propTypes2.default.string
};

AlertSymbol.defaultProps = {
  width: 40,
  height: 40,
  color: '#ff3b3c'
};

exports.default = AlertSymbol;